import axios from 'axios';
import {
    Toast,Dialog 
} from 'vant';
import router from '../router';
import utils from './common';
import { isWeChatApplet } from "@/utils/util";
let baseURL = 'https://api-pre.chinabeego.com/';
let env = window.localStorage.getItem('env') || 'sc-pre';
let _islogo = false;
baseURL = env == 'test' && 'https://api-test.chinabeego.com/' || baseURL;
baseURL = env == 'testb' && 'https://api-testb.chinabeego.com/' || baseURL;
baseURL = env == 'testc' && 'https://api-testc.chinabeego.com/' || baseURL;
baseURL = env == 'testd' && 'https://api-testd.chinabeego.com/' || baseURL;
baseURL = env == 'teste' && 'https://api-teste.chinabeego.com/' || baseURL;
baseURL = env == 'testf' && 'https://api-teste.chinabeego.com/' || baseURL;
baseURL = env == 'pre' && 'https://api-pre.chinabeego.com/' || baseURL;
baseURL = env == 'preb' && 'https://api-preb.chinabeego.com/' || baseURL;
baseURL = env == 'idc' && 'https://api3.chinabeego.com/' || baseURL;
baseURL = env == 'sc-pre' && 'https://scapi-pre.scjumax.com/' || baseURL;

baseURL = 'https://api-pre.scjumax.com';
// baseURL = 'https://api-pre.chinabeego.com/';
// console.log(baseURL);
if (process.env.NODE_ENV == 'production') {
    baseURL = process.env.VUE_APP_BASEURL
}

export default function _axios(_obj) {
    let obj = {
        baseURL: baseURL,
        method: _obj.method,
        url: _obj.url,
        headers: _obj.headers ? _obj.headers :{}
    }
    if (_obj.method == 'get' || _obj.method == 'GET') {
        obj.parmes = _obj.parmes;
    } else {
        obj.data = _obj.parmes
    }

    if (sessionStorage.getItem('token')) {
        obj.headers = {
            withCredentials: false,
            token: sessionStorage.getItem('token')
        }
    }

    if (sessionStorage.getItem('utmInfo')) {
        obj.headers.utmInfo = sessionStorage.getItem('utmInfo')
    }
    // 云信网页版
    if (window.isWebIM) {
      obj.headers['small-type'] = 'small';
    }
    //用户小程序
    // obj.headers['small-type'] = 'small';
    if (window.isApp === 'miniApp') {
        obj.headers['small-type'] = 'small';
    }
    //企业微信员工端小程序
    if (window.isApp === 'wxwork') {
        obj.headers['small-type'] = 'qwxsmall'
    }
    //云闪付小程序
    if (window.isApp === 'unionpay') {
        obj.headers['small-type'] = 'small';
        obj.headers.appId = '6cb0649ecd88473f94815142a277d29c'
        // obj.headers.appId = process.env.VUE_APP_CURRENTMODE == 'prod' ? '6cb0649ecd88473f94815142a277d29c' : 'a00848195c78488791e13422f9e2eeb3'
    }
    // obj.headers['small-type']='small';
    obj.headers['client-info'] = JSON.stringify(window.tools.getClientInfoFun())
    if(sessionStorage.getItem('tenant_code')){
        obj.headers['tenant_code'] =  sessionStorage.getItem('tenant_code') || '75c8dm'
        
    }
    let localRoute = localStorage.getItem('route');
    if (localRoute) {
      //请求头不能有中文，这里对中文做编码处理
      localRoute = localRoute.replace(/[\u4e00-\u9fa5]+/g, (val) => encodeURIComponent(val));
      obj.headers['route'] = localRoute || '';
    }
    if(_obj.url.indexOf('/sys/tenant/config')>-1){
        delete obj.headers['token']
    }

    // 品牌统一客服需求 聊天窗口跳转h5，header需要传入这两个值给后端
    // 在src/permission.js存储
    const imaccount = sessionStorage.getItem('imaccount')
    const imcustomerbranchid = sessionStorage.getItem('imcustomerbranchid')
    const source_tenant_code = sessionStorage.getItem('source_tenant_code');

    if (imaccount && imcustomerbranchid) {
      obj.headers.imaccount = imaccount;
      obj.headers.imcustomerbranchid = imcustomerbranchid;
    }
    if (source_tenant_code) {
      // 真正要查询的租户
      obj.headers.source_tenant_code = source_tenant_code;
    }

    if(process.env.NODE_ENV !== 'production') {
        // obj.headers['tenant_code'] ='75c8dm';
        // obj.headers['tenant_code'] ='75c8dm';
        
        // obj.headers['small-type'] = 'small';
        // obj.headers['client-info'] = JSON.stringify({"lng":114.24779,"lat":22.71991,"phone_model":"iPhone X","phone_brand":"devtools","client_version":"2.23.29","client_type":"miniApp","user_id":"","usertype":"user","version_int":22329,"gioVisitUserId":"825365f2-ae94-475b-866b-f0e6c23714b5","version":"iOS 10.0.1","fromUser":""})

    }
    // console.log(_obj);
    if(_obj.method == "upload"){
        
        obj.method = 'post'
        // console.log(18919191);
        obj.headers['loginType'] = 'LOGIN_ADMIN_PASSWORD'
        obj.headers['content-type'] = 'multipart/form-data'
        delete obj.data
        let formData = new window.FormData();
        for(let i in _obj.params){
          formData.append(i,_obj.params[i])
        }
        // return
        // formData.append(_obj.params.formData)
        // formData = _obj.formData
        // console.log(formData);
        obj.data = formData
        // console.log(11112);
        // console.log(obj);
    }
 
    return new Promise((resolve, reject) => {
        axios(obj).then(res => {
            if (res.status == 200) {
                if(typeof res.data == 'string'){
                    res.data = JSON.parse(res.data)
                }
                if (res.data.code == 200) {
                    resolve(res.data)
                } else {
                    console.log(res.data.code)
                    if (res.data.code == 401) {
                        if(!_islogo){
                            _islogo =true;
                            sessionStorage.clear();
                            if (window.isApp ==='Android' || window.isApp ==='IOS') {
                                utils.needUserLogin();
                            } else if (window.isApp === 'miniApp') {
                                wx.miniProgram.navigateTo({ url: "/others/pages/author-login/index?fromurl=WEBVIEW"})
                            } else if (window.isApp === 'wxwork') {
                                wx.miniProgram.navigateTo({ url: "/packages/main/pages/login/index" })
                            }else if (window.isApp === 'unionpay') {
                                // 云闪付
                                _islogo = false
                                Dialog.confirm({
                                    title: '温馨提示',
                                    message:'登陆后才可以使用本小程序哦',
                                  }).then(() => {
                                    router.push({ path: '/unionpayLogin' })
                                }).catch(() => {
                                    router.replace({ path: '/unionpayHome' })
                                });
                                reject(res.data);
                            }
                        }
                        return
                    }
                    Toast(res.data.message || '请求失败');
                    reject(res.data);
                }
            } else {
                Toast('网络异常');
                reject('接口凉了')
            }
        }).catch((err) => {
            console.log('===catch===', err)
            reject(err);
        })
    })
}
